import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  CheckboxInput,
  CustomTable,
  ModalError,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

export default function AddSongModal({
  open,
  onClose,
  filterParams = {},
  selectedSongs = [],
  setSelectedSongs,
}) {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleAddSong = option => {
    const isSongSelected = selectedSongs.some(
      item => item.song_id === option?.song_id
    );
    setSelectedSongs(prev =>
      isSongSelected
        ? prev.filter(item => item.song_id !== option.song_id)
        : [...prev, option]
    );
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/publisher/transaction-song`, {
        headers,
        params: { ...queryParams, ...filterParams },
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Add Song</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <SearchTextInput
            placeholder="Search"
            value={queryParams?.search}
            onChange={e => handleChangeQueryParams(e?.target?.value, "search")}
            width="400px"
          />
        </Box>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columns}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          rowClick={item => handleAddSong(item)}
          isHaveAction
          renderAction={item => (
            <CheckboxInput
              checked={selectedSongs?.some(
                selected => selected?.song_id === item?.song_id
              )}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <PrimaryButton label="Close" onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
}

const columns = [
  {
    name: "song_title",
    title: "Song Title",
  },
  {
    name: "composer_names",
    title: "Composer",
    renderText: item => <ArrayChip list={item} />,
  },
];
